import React from 'react';
import cx from 'classnames';

import Button from '~/components/button';
import { useModal } from '~/features/modals/modal-actions';
import FaqModalContent from '~/components/modals/plan-faqs/lawn-plan-faq-content';

import styles from '~/components/plans/bundles-page/plan-faq-trigger.module.scss';

const PlanFaqTrigger = ({ className, faqContent = FaqModalContent }) => {
  const { showModal } = useModal();

  return (
    <div className={cx(className, styles.planFaqTrigger)}>
      <img
        alt="Question mark"
        src="/icons/blue-question.svg"
        height={54}
        width={47}
      />
      <p>Still have questions?</p>
      <Button
        onClick={() => showModal('PLAN_FAQS', { faqContent })}
        variant="transparentGreen"
      >
        See all FAQs
      </Button>
    </div>
  );
};

export default PlanFaqTrigger;
